const data = {
    defaultSelectAll: false,
    performanceExamineDerates: [],
    selectItem: {},
    isFirstSearch: true,
    detialFlag: false,
    frontUrl: '',
    resourceCode: '',
    reasonRow: {},
    examrow: {},
    dictData: {},
    searchInfo: {
        businessCategory: '',
        companyCode: '',
        companyName: '',
        siteName: '',
        siteCode: '',
        supplierCode: '',
        supplierName: '',
        startDate: '',
        endDate: '',
        dailyStatus: '',
        examineId: ''
    },
    pageInfo: {
        pageNo: 1,
        pageSize: 10
    },
    daylist: [],
    showFlagType: 1,
    isExamineDialog: false,
    title: '',
    showFlag: false,
    showModal: false,
    totalCount: 0,
    columnNum: 100,
    checkedList: '',
    selectAllColumns: [
        {
            'prop': 'examineId',
            'label': '考核单编号',
            'width': '180'
        },
        {
            'prop': 'assessmentDate',
            'label': '单据时间',
            'width': '180'
        },
        {
            'prop': 'professionalCompany',
            'label': '专司',
            'width': '180'
        },
        {
            'prop': 'companyName',
            'label': '分公司',
            'width': '180'
        },
        {
            'prop': 'siteName',
            'label': '平台',
            'width': '180'
        },
        {
            'prop': 'businessTypeText',
            'label': '业务类型',
            'width': '180'
        },
        {
            'prop': 'businessCategoryText',
            'label': '业务大类',
            'width': '180'
        },
        {
            'prop': 'supplierName',
            'label': '供应商',
            'width': '180'
        },
        {
            'prop': 'driverName',
            'label': '司机名称',
            'width': '180'
        },
        {
            'prop': 'licensePlateNumber',
            'label': '车牌号码',
            'width': '180'
        },
        {
            'prop': 'contactMobile',
            'label': '手机号码',
            'width': '180'
        },
        {
            'prop': 'lineName',
            'label': '线路',
            'width': '180'
        },
        {
            'prop': 'custNo',
            'label': '客户订单号',
            'width': '180'
        },
        {
            'prop': 'ettaNo',
            'label': '运输单',
            'width': '180'
        },
        {
            'prop': 'ettaDoNo',
            'label': '发车单',
            'width': '180'
        },
        {
            'prop': 'quotaName',
            'label': '指标名称',
            'width': '120'
        },
        {
            'prop': 'reachStandard',
            'label': '是否达标',
            'width': '120'
        },
        {
            'prop': 'fineAmount',
            'label': '罚扣款金额',
            'width': '120'
        },
        {
            'prop': 'confirmUserName',
            'label': '确认人',
            'width': '120'
        },
        {
            'prop': 'dailyStatusText',
            'label': '状态',
            'width': '120'
        },
        {
            'prop': 'requestTime',
            'label': '要求完成时间',
            'width': '150'
        },
        {
            'prop': 'realTime',
            'label': '实际完成时间',
            'width': '150'
        },
        {
            'prop': 'appealTime',
            'label': '可申诉时间',
            'width': '120'
        }
    ],
    'columnsList': [
        {
            'prop': 'examineId',
            'label': '考核单编号',
            'width': '180'
        },
        {
            'prop': 'assessmentDate',
            'label': '单据时间',
            'width': '180'
        },
        {
            'prop': 'professionalCompany',
            'label': '专司',
            'width': '180'
        },
        {
            'prop': 'companyName',
            'label': '分公司',
            'width': '180'
        },
        {
            'prop': 'siteName',
            'label': '平台',
            'width': '180'
        },
        {
            'prop': 'businessTypeText',
            'label': '业务类型',
            'width': '180'
        },
        {
            'prop': 'businessCategoryText',
            'label': '业务大类',
            'width': '180'
        },
        {
            'prop': 'supplierName',
            'label': '供应商',
            'width': '180'
        },
        {
            'prop': 'driverName',
            'label': '司机名称',
            'width': '180'
        },
        {
            'prop': 'licensePlateNumber',
            'label': '车牌号码',
            'width': '180'
        },
        {
            'prop': 'contactMobile',
            'label': '手机号码',
            'width': '180'
        },
        {
            'prop': 'lineName',
            'label': '线路',
            'width': '180'
        },
        {
            'prop': 'custNo',
            'label': '客户订单号',
            'width': '180'
        },
        {
            'prop': 'ettaNo',
            'label': '运输单',
            'width': '180'
        },
        {
            'prop': 'ettaDoNo',
            'label': '发车单',
            'width': '180'
        },
        {
            'prop': 'quotaName',
            'label': '指标名称',
            'width': '120'
        },
        {
            'prop': 'reachStandard',
            'label': '是否达标',
            'width': '120'
        },
        {
            'prop': 'fineAmount',
            'label': '罚扣款金额',
            'width': '120'
        },
        {
            'prop': 'confirmUserName',
            'label': '确认人',
            'width': '120'
        },
        {
            'prop': 'dailyStatusText',
            'label': '状态',
            'width': '120'
        },
        {
            'prop': 'requestTime',
            'label': '要求完成时间',
            'width': '150'
        },
        {
            'prop': 'realTime',
            'label': '实际完成时间',
            'width': '150'
        },
        {
            'prop': 'appealTime',
            'label': '可申诉时间',
            'width': '120'
        }
    ]
};
export default data;